export const defaultState = {
  fetching: false,
  result: null,
  error: null,
};
